import { t } from "i18next";

import { queryClient } from "#app/http/ReactQueryProvider";
import { usePredictParts } from "#modules/quoteRequestLines/usePredictParts";
import { useValidFilesTypes } from "#modules/quoteRequestLines/useValidFileTypes";
import { useAssembliesContext } from "#modules/quoteRequests/context/AssembliesContext";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";
import { SimpleDropzone } from "#shared/view/components/SimpleDrozone/SimpleDropzone";
import { UPLOAD_CONFIG } from "shared";

type Props = {
  quoteRequestId: string | undefined;
};

export const ImportNewPartDropZone = ({ quoteRequestId }: Props) => {
  const { assemblies } = useAssembliesContext();

  const { onDropFile, progress } = usePredictParts({
    currentQuoteRequestLineIndex: assemblies.length,
    onSuccess: (currentQuoteRequestId: string) => {
      void queryClient.invalidateQueries(quoteRequestQuery(currentQuoteRequestId));
    },
    quoteRequestId,
  });
  const { validExtensions, accept } = useValidFilesTypes("predict");

  return (
    <SimpleDropzone
      title={t("qr.dropzone.title")}
      subTitle={t("qr.dropzone.subTitle")}
      onDrop={onDropFile}
      validExtensions={validExtensions}
      accept={accept}
      uploadProgress={progress}
      maxSize={UPLOAD_CONFIG.PART.maxFileSize}
    />
  );
};
